<template>
    <div class="sustainable-component admin-register-maintenance" style="position:relative;">
        <div class="container-fluid p-0 mt-3">
            <div class="row">
                <div class="col-12">
                    <v-alert type="info" variant="tonal" class="register-maintenance-info-alert">
                        {{ $t('admin.registerMaintenance.dryRunInfo') }}
                    </v-alert>
                </div>
            </div>

            <div class="row register-maintenance-upload-row">
                <div class="col-12 col-lg-6">
                    <v-form ref="uploadForm" action="/admin/AnalyzeRegisterMaintenanceFiles" method="post" enctype="multipart/form-data" @submit.prevent="handleSubmit">
                        <CommonLabelContainer :title="$t('admin.registerMaintenance.uploadTitle')" class="mb-3">
                            <div class="container-fluid mt-3">
                                <div class="row">
                                    <div class="col-12">
                                        <v-file-input
                                            v-model="departmentsFile"
                                            accept=".csv"
                                            name="departmentsFile"
                                            :label="$t('admin.registerMaintenance.departmentsFileLabel')"></v-file-input>
                                    </div>
                                    <div class="col-12">
                                        <v-file-input
                                            v-model="clubsFile"
                                            accept=".csv"
                                            name="clubsFile"
                                            :label="$t('admin.registerMaintenance.clubsFileLabel')"></v-file-input>
                                    </div>
                                    <div class="col-12">
                                        <v-file-input
                                            v-model="workspacesFile"
                                            accept=".csv"
                                            name="workspacesFile"
                                            :label="$t('admin.registerMaintenance.workspacesFileLabel')"></v-file-input>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12 d-flex flex-wrap ga-2">
                                        <v-btn :text="$t('admin.registerMaintenance.analyzeButton')" type="submit"></v-btn>
                                        <v-btn
                                            :text="$t('admin.registerMaintenance.refreshFromStagingButton')"
                                            variant="outlined"
                                            @click="refreshFromStaging"></v-btn>
                                    </div>
                                </div>
                            </div>
                        </CommonLabelContainer>
                    </v-form>
                </div>
                <div class="col-12 col-lg-6">
                    <CommonLabelContainer :title="$t('admin.registerMaintenance.expectedFormatTitle')" class="mb-3">
                        <div class="mt-3">
                            <p>{{ $t('admin.registerMaintenance.orderIntro') }}</p>
                            <p class="mb-2"><strong>{{ $t('admin.registerMaintenance.technicalRequirementsTitle') }}</strong></p>
                            <ul>
                                <li>{{ $t('admin.registerMaintenance.requirementEncoding') }}</li>
                                <li>{{ $t('admin.registerMaintenance.requirementDelimiter') }}</li>
                                <li>{{ $t('admin.registerMaintenance.requirementHeaders') }}</li>
                                <li>{{ $t('admin.registerMaintenance.requirementAllFiles') }}</li>
                            </ul>
                            <p class="mb-2"><strong>departments.csv</strong></p>
                            <code class="d-block mb-3">{{ departmentsHeaders }}</code>
                            <p class="mb-2"><strong>clubs.csv</strong></p>
                            <code class="d-block mb-3">{{ clubsHeaders }}</code>
                            <p class="mb-2"><strong>workspaces.csv</strong></p>
                            <code class="d-block mb-3">{{ workspacesHeaders }}</code>
                            <v-alert type="warning" variant="tonal" class="mt-3">
                                {{ $t('admin.registerMaintenance.clubRequirementWarning') }}
                            </v-alert>
                            <v-expansion-panels class="mt-3 matching-guide-panels" variant="accordion">
                                <v-expansion-panel>
                                    <v-expansion-panel-title class="matching-guide-panel-title">
                                        <v-icon icon="mdi-information-outline" size="small" color="primary" class="matching-guide-icon"></v-icon>
                                        <span>{{ $t('admin.registerMaintenance.matchingGuideTitle') }}</span>
                                    </v-expansion-panel-title>
                                    <v-expansion-panel-text>
                                        <div class="matching-guide">
                                            <section class="matching-guide-section">
                                                <h6 class="matching-guide-heading">{{ $t('admin.registerMaintenance.matchingGuideDepartmentTitle') }}</h6>
                                                <p class="matching-guide-text">{{ $t('admin.registerMaintenance.matchingGuideDepartmentText') }}</p>
                                            </section>

                                            <section class="matching-guide-section">
                                                <h6 class="matching-guide-heading">{{ $t('admin.registerMaintenance.matchingGuideClubTitle') }}</h6>
                                                <p class="matching-guide-text">{{ $t('admin.registerMaintenance.matchingGuideClubText') }}</p>
                                                <div class="matching-guide-note">
                                                    <v-icon icon="mdi-information-outline" size="small" class="matching-guide-note-icon"></v-icon>
                                                    <div>
                                                        <strong>{{ $t('admin.registerMaintenance.matchingGuideClubDiffTitle') }}</strong>
                                                        <p class="matching-guide-text mb-0">{{ $t('admin.registerMaintenance.matchingGuideClubDiffText') }}</p>
                                                    </div>
                                                </div>
                                                <div class="matching-guide-note">
                                                    <v-icon icon="mdi-information-outline" size="small" class="matching-guide-note-icon"></v-icon>
                                                    <div>
                                                        <strong>{{ $t('admin.registerMaintenance.matchingGuideClubDuplicatesTitle') }}</strong>
                                                        <p class="matching-guide-text mb-0">{{ $t('admin.registerMaintenance.matchingGuideClubDuplicatesText') }}</p>
                                                    </div>
                                                </div>
                                            </section>

                                            <section class="matching-guide-section">
                                                <h6 class="matching-guide-heading">{{ $t('admin.registerMaintenance.matchingGuideWorkplaceTitle') }}</h6>
                                                <p class="matching-guide-text">{{ $t('admin.registerMaintenance.matchingGuideWorkplaceText') }}</p>
                                                <div class="matching-guide-note">
                                                    <v-icon icon="mdi-information-outline" size="small" class="matching-guide-note-icon"></v-icon>
                                                    <div>
                                                        <strong>{{ $t('admin.registerMaintenance.matchingGuideWorkplaceFallbackTitle') }}</strong>
                                                        <p class="matching-guide-text mb-0">{{ $t('admin.registerMaintenance.matchingGuideWorkplaceFallbackText') }}</p>
                                                    </div>
                                                </div>
                                                <div class="matching-guide-note">
                                                    <v-icon icon="mdi-information-outline" size="small" class="matching-guide-note-icon"></v-icon>
                                                    <div>
                                                        <strong>{{ $t('admin.registerMaintenance.matchingGuideWorkplaceClassificationTitle') }}</strong>
                                                        <p class="matching-guide-text mb-0">{{ $t('admin.registerMaintenance.matchingGuideWorkplaceClassificationText') }}</p>
                                                    </div>
                                                </div>
                                            </section>

                                            <section class="matching-guide-section">
                                                <h6 class="matching-guide-heading">{{ $t('admin.registerMaintenance.matchingGuideEmptyFieldsTitle') }}</h6>
                                                <p class="matching-guide-text">{{ $t('admin.registerMaintenance.matchingGuideEmptyFieldsText') }}</p>
                                            </section>

                                            <section class="matching-guide-section matching-guide-section-last">
                                                <h6 class="matching-guide-heading">{{ $t('admin.registerMaintenance.matchingGuideTextComparisonTitle') }}</h6>
                                                <p class="matching-guide-text mb-0">{{ $t('admin.registerMaintenance.matchingGuideTextComparisonText') }}</p>
                                            </section>
                                        </div>
                                    </v-expansion-panel-text>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </div>
                    </CommonLabelContainer>
                </div>
            </div>

            <div class="row mt-3" v-if="errorMessages.length > 0">
                <div class="col-12">
                    <v-alert type="error" :title="$t('admin.registerMaintenance.errorTitle')">
                        <div v-for="(item, index) in errorMessages" :key="index">{{ item }}</div>
                    </v-alert>
                </div>
            </div>

            <div v-if="result" class="row mt-3">
                <div class="col-12">
                    <CommonLabelContainer :title="$t('admin.registerMaintenance.resultTitle')">
                        <div class="container-fluid mt-3">
                            <div class="row g-3">
                                <div class="col-12 col-md-3">
                                    <div class="report-dashboard-card">
                                        <div class="dashboard-label">{{ $t('admin.registerMaintenance.importedAt') }}</div>
                                        <div class="dashboard-value">{{ result.ImportedAt || '-' }}</div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-3">
                                    <div class="report-dashboard-card">
                                        <div class="dashboard-label">{{ $t('admin.registerMaintenance.status') }}</div>
                                        <v-chip size="small" :color="statusColor(result.Status)" variant="tonal">
                                            {{ result.Status }}
                                        </v-chip>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="report-dashboard-card">
                                        <div class="dashboard-label">{{ $t('admin.registerMaintenance.file') }}</div>
                                        <div class="dashboard-file-name">{{ result.FileName }}</div>
                                    </div>
                                </div>
                                <div class="col-12" v-if="result.Status === 'Completed'">
                                    <v-btn
                                        color="primary"
                                        :text="$t('admin.registerMaintenance.applyButton')"
                                        @click="openApplyDialog"></v-btn>
                                </div>
                            </div>
                        </div>
                    </CommonLabelContainer>
                </div>

                <div class="col-12 mt-3">
                    <v-tabs color="primary" v-model="selectedObjectType">
                        <v-tab v-for="objectType in objectTypes" :key="objectType" :value="objectType">{{ objectType }}</v-tab>
                    </v-tabs>

                    <div class="summary-dashboard mt-3" v-if="selectedObjectSummaries.length > 0">
                        <div class="summary-card" v-for="summary in selectedObjectSummaries" :key="summary.ObjectType + '-' + summary.Outcome">
                            <div class="summary-card-header">
                                <span>{{ summary.ObjectType }}</span>
                                <span class="summary-outcome" :class="summaryOutcomeClass(summary.Outcome)">
                                    {{ outcomeText(summary.Outcome) }}
                                </span>
                            </div>
                            <div class="summary-count">{{ summary.Count }}</div>
                        </div>
                    </div>

                    <div class="mt-3 mb-3">
                        <v-chip-group v-model="selectedOutcome" filter>
                            <v-tooltip location="top" :text="outcomeTooltip('')">
                                <template #activator="{ props }">
                                    <v-chip v-bind="props" value="">{{ $t('admin.registerMaintenance.allOutcomes') }} ({{ allOutcomeCount }})</v-chip>
                                </template>
                            </v-tooltip>
                            <v-tooltip v-for="outcome in outcomes" :key="outcome" location="top" :text="outcomeTooltip(outcome)">
                                <template #activator="{ props }">
                                    <v-chip v-bind="props" :value="outcome">{{ outcomeText(outcome) }} ({{ outcomeCount(outcome) }})</v-chip>
                                </template>
                            </v-tooltip>
                        </v-chip-group>
                    </div>

                    <div v-if="filteredItems.length > tablePageSize" class="register-maintenance-pagination mt-2">
                        <v-btn size="small" variant="tonal" :disabled="tablePage <= 1" @click="tablePage = tablePage - 1">Föregående</v-btn>
                        <span class="register-maintenance-pagination-label">
                            Sida {{ tablePage }} av {{ totalTablePages }} ({{ filteredItems.length }} rader)
                        </span>
                        <v-btn size="small" variant="tonal" :disabled="tablePage >= totalTablePages" @click="tablePage = tablePage + 1">Nästa</v-btn>
                    </div>

                    <div class="register-maintenance-table-wrapper">
                        <table class="mt-2 table table-light table-hover table-striped register-maintenance-table" cellspacing="0" cellpadding="8" border="0">
                            <thead>
                                <tr>
                                    <th class="result-column">{{ $t('admin.registerMaintenance.tableOutcome') }}</th>
                                    <th class="row-column">{{ $t('admin.registerMaintenance.tableRow') }}</th>
                                    <th class="key-column">{{ $t('admin.registerMaintenance.tableExternalKey') }}</th>
                                    <th class="action-column"></th>
                                    <th class="message-column">{{ $t('admin.registerMaintenance.tableMessage') }}</th>
                                    <th class="values-column">{{ $t('admin.registerMaintenance.tableCurrentValues') }}</th>
                                    <th class="values-column">{{ $t('admin.registerMaintenance.tableIncomingValues') }}</th>
                                    <th class="values-column">{{ $t('admin.registerMaintenance.tableDifferences') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in pagedItems" :key="itemRowKey(item)">
                                    <td>{{ outcomeText(item.Outcome) }}</td>
                                    <td>{{ item.SheetName }} {{ item.RowNumber }}</td>
                                    <td>{{ item.ExternalKey }}</td>
                                    <td>
                                        <v-btn v-if="reviewFilter(item)"
                                               icon="mdi-magnify"
                                               size="x-small"
                                               variant="tonal"
                                               title="Sök i adminvy"
                                               @click="openReviewWindow(item)"></v-btn>
                                    </td>
                                    <td class="text-cell">{{ item.Message }}</td>
                                    <td class="dictionary-cell">
                                        <div v-for="entry in dictionaryEntries(item.CurrentValues, item.Differences)" :key="entry.key" :class="dictionaryEntryClass(item, entry.key)">
                                            <strong>{{ entry.key }}:</strong> <span class="dictionary-value">{{ entry.value }}</span>
                                        </div>
                                    </td>
                                    <td class="dictionary-cell">
                                        <div v-for="entry in dictionaryEntries(item.IncomingValues, item.Differences)" :key="entry.key" :class="dictionaryEntryClass(item, entry.key)">
                                            <strong>{{ entry.key }}:</strong> <span class="dictionary-value">{{ entry.value }}</span>
                                        </div>
                                    </td>
                                    <td class="dictionary-cell">
                                        <div v-for="entry in dictionaryEntries(item.Differences)" :key="entry.key" class="difference-entry">
                                            <strong>{{ entry.key }}:</strong> <span class="dictionary-value">{{ entry.value }}</span>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <common-spinner v-bind:loading="loading || applyLoading"></common-spinner>

        <v-dialog v-model="applyDialogOpen" max-width="720">
                <v-card>
                    <v-card-title>{{ $t('admin.registerMaintenance.applyConfirmTitle') }}</v-card-title>
                    <v-card-text>
                        <p>{{ $t('admin.registerMaintenance.applyConfirmIntro') }}</p>
                        <v-alert v-if="applyPreflightError" type="error" variant="tonal" class="mb-3">
                            {{ applyPreflightError }}
                        </v-alert>
                        <div v-if="applyPreflight">
                            <p><strong>{{ $t('admin.registerMaintenance.applyConfirmApplicable') }}:</strong> {{ applyPreflight.ApplicableCount }}</p>
                            <p v-if="applyPreflight.DeferredCount > 0"><strong>{{ $t('admin.registerMaintenance.applyConfirmDeferred') }}:</strong> {{ applyPreflight.DeferredCount }}</p>
                            <p><strong>{{ $t('admin.registerMaintenance.applyConfirmSkipped') }}:</strong> {{ applyPreflight.SkippedCount }}</p>
                            <div class="mt-3" v-if="applyPreflight.ApplicableSummary && applyPreflight.ApplicableSummary.length">
                                <div v-for="summary in applyPreflight.ApplicableSummary" :key="'apply-' + summary.ObjectType + summary.Outcome">
                                    {{ summary.ObjectType }} · {{ outcomeText(summary.Outcome) }} · {{ summary.Count }}
                                </div>
                            </div>
                            <div class="mt-3" v-if="applyPreflight.DeferredSummary && applyPreflight.DeferredSummary.length">
                                <div v-for="summary in applyPreflight.DeferredSummary" :key="'deferred-' + summary.ObjectType + summary.Outcome">
                                    {{ summary.ObjectType }} · {{ outcomeText(summary.Outcome) }} · {{ summary.Count }}
                                </div>
                            </div>
                        </div>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn :text="$t('admin.registerMaintenance.applyConfirmCancel')" @click="applyDialogOpen = false"></v-btn>
                        <v-btn
                            color="primary"
                            :disabled="!applyPreflight || applyPreflight.ApplicableCount === 0"
                            :text="$t('admin.registerMaintenance.applyConfirmProceed')"
                            @click="confirmApply"></v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="applyResultDialogOpen" max-width="720">
                <v-card>
                    <v-card-title>{{ $t('admin.registerMaintenance.applyResultTitle') }}</v-card-title>
                    <v-card-text>
                        <v-alert :type="applyResult && applyResult.Status === 'Completed' ? 'success' : 'error'" variant="tonal" class="mb-3">
                            {{ applyResult && applyResult.Status === 'Completed'
                                ? $t('admin.registerMaintenance.applySuccessDepartmentsAndClubs')
                                : $t('admin.registerMaintenance.applyFailed') }}
                        </v-alert>
                        <div v-if="applyResult && applyResult.WriteCounts">
                            <p>{{ $t('admin.registerMaintenance.applySummaryDepartments') }}: {{ applyResult.WriteCounts.DepartmentsInserted }} / {{ applyResult.WriteCounts.DepartmentsUpdated }}</p>
                            <p>{{ $t('admin.registerMaintenance.applySummaryClubs') }}: {{ applyResult.WriteCounts.ClubsInserted }} / {{ applyResult.WriteCounts.ClubsUpdated }}</p>
                            <p v-if="applyResult.DeferredCount > 0">{{ $t('admin.registerMaintenance.applySummaryDeferred') }}: {{ applyResult.DeferredCount }}</p>
                            <p>{{ $t('admin.registerMaintenance.applySummarySkipped') }}: {{ applyResult.SkippedCount }}</p>
                            <p class="mt-2" v-if="applyResult.DeferredCount > 0">{{ $t('admin.registerMaintenance.applyWorkplacesDeferredNote') }}</p>
                        </div>
                        <div v-if="applyResult && applyResult.ErrorMessages && applyResult.ErrorMessages.length">
                            <div v-for="(message, index) in applyResult.ErrorMessages" :key="'apply-error-' + index">{{ message }}</div>
                        </div>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="primary" text="OK" @click="applyResultDialogOpen = false"></v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
    </div>
</template>

<script>
    import CommonLabelContainer from "../../common/common-label-container";
    import ValidationService from "../../Services/ValidationService";
    import CommonSpinner from '../../common/common-spinner.vue'

    export default {
        name: 'admin-register-maintenance',
        components: {
            CommonLabelContainer,
            CommonSpinner
        },
        mounted() {
            this.reloadCurrentImport(false);
        },
        methods: {
            resolveUploadFile(value, inputName, form) {
                if (value instanceof File) {
                    return value;
                }

                if (Array.isArray(value) && value.length > 0 && value[0] instanceof File) {
                    return value[0];
                }

                if (form && inputName) {
                    const input = form.querySelector(`input[name="${inputName}"]`);
                    if (input && input.files && input.files.length > 0) {
                        return input.files[0];
                    }
                }

                return null;
            },
            buildUploadFormData(form) {
                const departments = this.resolveUploadFile(this.departmentsFile, "departmentsFile", form);
                const clubs = this.resolveUploadFile(this.clubsFile, "clubsFile", form);
                const workspaces = this.resolveUploadFile(this.workspacesFile, "workspacesFile", form);

                if (!departments && !clubs && !workspaces) {
                    return null;
                }

                const formData = new FormData();
                if (departments) {
                    formData.append("departmentsFile", departments);
                }
                if (clubs) {
                    formData.append("clubsFile", clubs);
                }
                if (workspaces) {
                    formData.append("workspacesFile", workspaces);
                }
                return formData;
            },
            async handleSubmit(event) {
                this.loading = true;
                this.errorMessages = [];
                const form = event.currentTarget;
                const formData = this.buildUploadFormData(form);

                if (!formData) {
                    this.loading = false;
                    this.errorMessages = [this.$t('admin.registerMaintenance.requiredAtLeastOneCsvFile')];
                    return;
                }

                try {
                    const response = await fetch(new URL(form.action), {
                        method: form.method,
                        body: formData
                    });

                    if (!response.ok) {
                        this.errorMessages = [this.$t('admin.registerMaintenance.uploadFailed')];
                        return;
                    }

                    const json = await response.json();
                    this.result = json;
                    this.errorMessages = json.ErrorMessages || [];
                    this.selectedObjectType = this.objectTypes[0] || "";
                    this.tablePage = 1;
                } finally {
                    this.loading = false;
                }
            },
            async refreshFromStaging() {
                this.loading = true;
                this.errorMessages = [];

                try {
                    const loaded = await this.reloadCurrentImport(true);
                    if (!loaded) {
                        this.errorMessages = [this.$t('admin.registerMaintenance.refreshFromStagingEmpty')];
                    }
                } finally {
                    this.loading = false;
                }
            },
            async openApplyDialog() {
                this.applyPreflight = null;
                this.applyPreflightError = "";
                this.applyDialogOpen = true;
                this.applyLoading = true;

                try {
                    const response = await fetch("/Admin/GetRegisterMaintenanceApplyPreflight?applyScope=" + encodeURIComponent(this.applyScope));
                    if (!response.ok) {
                        this.applyPreflightError = this.$t('admin.registerMaintenance.applyFailed');
                        return;
                    }

                    const json = await response.json();
                    if (json.ErrorMessages && json.ErrorMessages.length > 0) {
                        this.applyPreflightError = json.ErrorMessages.join(" ");
                    }

                    this.applyPreflight = json;
                } finally {
                    this.applyLoading = false;
                }
            },
            async confirmApply() {
                this.applyLoading = true;

                try {
                    const response = await fetch("/Admin/ApplyRegisterMaintenanceImport?applyScope=" + encodeURIComponent(this.applyScope), {
                        method: "POST"
                    });

                    if (!response.ok) {
                        this.applyResult = {
                            Status: "Failed",
                            ErrorMessages: [this.$t('admin.registerMaintenance.applyFailed')]
                        };
                        this.applyDialogOpen = false;
                        this.applyResultDialogOpen = true;
                        return;
                    }

                    const json = await response.json();
                    this.applyResult = json;
                    this.applyDialogOpen = false;
                    this.applyResultDialogOpen = true;

                    if (json.Status === "Completed") {
                        await this.reloadCurrentImport(false);
                    }
                } finally {
                    this.applyLoading = false;
                }
            },
            async reloadCurrentImport(showEmptyAsError) {
                const response = await fetch("/Admin/GetRegisterMaintenanceCurrentImport");
                if (!response.ok) {
                    return false;
                }

                const json = await response.json();
                if (json.Status === "Empty") {
                    this.result = null;
                    if (showEmptyAsError) {
                        this.errorMessages = json.ErrorMessages || [];
                    }
                    return false;
                }

                this.result = json;
                this.errorMessages = json.ErrorMessages || [];
                this.selectedObjectType = this.objectTypes[0] || "";
                this.tablePage = 1;
                return true;
            },
            outcomeText(outcome) {
                return this.$t('admin.registerMaintenance.outcomes.' + outcome);
            },
            outcomeTooltip(outcome) {
                const key = outcome === "" ? "all" : outcome;
                return this.$t('admin.registerMaintenance.outcomeTooltips.' + key);
            },
            statusColor(status) {
                if (status === 'Completed') {
                    return 'success';
                }
                if (status === 'Failed') {
                    return 'error';
                }

                return 'primary';
            },
            summaryOutcomeClass(outcome) {
                return {
                    'summary-outcome-create': outcome === 'Create',
                    'summary-outcome-conflict': outcome === 'Conflict' || outcome === 'Invalid' || outcome === 'NeedsReview',
                    'summary-outcome-ignored': outcome === 'Ignored',
                    'summary-outcome-update': outcome === 'Update' || outcome === 'HierarchyChange' || outcome === 'RegisterKeyBackfill',
                    'summary-outcome-exists': outcome === 'Exists'
                };
            },
            dictionaryEntries(values, differences) {
                if (!values) {
                    return [];
                }

                return Object.keys(values)
                    .filter(key => this.shouldShowDictionaryEntry(values, differences, key))
                    .map(key => ({ key: key, value: values[key] }));
            },
            shouldShowDictionaryEntry(values, differences, key) {
                const value = values[key];
                return (value !== null && value !== undefined && value !== "")
                    || (differences && differences[key] !== null && differences[key] !== undefined);
            },
            dictionaryEntryClass(item, key) {
                return item.Differences && item.Differences[key] !== null && item.Differences[key] !== undefined
                    ? 'difference-entry'
                    : '';
            },
            reviewFilter(item) {
                if (!item || !item.IncomingValues) {
                    return "";
                }

                if (item.ObjectType === "Avdelning") {
                    return item.IncomingValues.DepartmentName || item.IncomingValues.Namn || "";
                }
                if (item.ObjectType === "Klubb") {
                    return item.IncomingValues.ClubName || item.IncomingValues.Namn || "";
                }
                if (item.ObjectType === "Arbetsplats") {
                    return item.IncomingValues.WorkspaceName || item.IncomingValues.Namn || "";
                }

                return "";
            },
            reviewUrl(item) {
                const filter = encodeURIComponent(this.reviewFilter(item));
                if (item.ObjectType === "Avdelning") {
                    return `/Admin/AdminDepartmentsAll?filter=${filter}`;
                }
                if (item.ObjectType === "Klubb") {
                    return `/Admin/AdminClub?filter=${filter}`;
                }
                if (item.ObjectType === "Arbetsplats") {
                    return `/Admin/AdminWorkspaceAll?filter=${filter}`;
                }

                return "";
            },
            openReviewWindow(item) {
                const url = this.reviewUrl(item);
                if (url) {
                    window.open(url, '', 'left=0,top=0,width=1100,height=900,toolbar=0,scrollbars=1,status=0');
                }
            },
            outcomeCount(outcome) {
                return this.itemsForSelectedObjectType
                    .filter(item => item.Outcome === outcome)
                    .length;
            },
            itemRowKey(item) {
                return `${item.ObjectType}-${item.SheetName}-${item.RowNumber}-${item.Outcome}`;
            }
        },
        computed: {
            objectTypes() {
                if (!this.result) {
                    return [];
                }

                return [...new Set(this.result.Items.map(item => item.ObjectType))];
            },
            outcomes() {
                return [...new Set(this.itemsForSelectedObjectType.map(item => item.Outcome))];
            },
            selectedObjectSummaries() {
                if (!this.result || !this.result.Summary) {
                    return [];
                }

                return this.result.Summary.filter(summary => summary.ObjectType === this.selectedObjectType);
            },
            itemsForSelectedObjectType() {
                if (!this.result) {
                    return [];
                }

                return this.result.Items.filter(item => !this.selectedObjectType || item.ObjectType == this.selectedObjectType);
            },
            allOutcomeCount() {
                return this.itemsForSelectedObjectType.length;
            },
            filteredItems() {
                if (!this.result) {
                    return [];
                }

                return this.itemsForSelectedObjectType.filter(item => !this.selectedOutcome || item.Outcome == this.selectedOutcome);
            },
            totalTablePages() {
                if (this.filteredItems.length === 0) {
                    return 1;
                }

                return Math.ceil(this.filteredItems.length / this.tablePageSize);
            },
            pagedItems() {
                const startIndex = (this.tablePage - 1) * this.tablePageSize;
                return this.filteredItems.slice(startIndex, startIndex + this.tablePageSize);
            }
        },
        watch: {
            selectedObjectType() {
                if (this.selectedOutcome && !this.outcomes.includes(this.selectedOutcome)) {
                    this.selectedOutcome = "";
                }

                this.tablePage = 1;
            },
            selectedOutcome() {
                this.tablePage = 1;
            }
        },
        data() {
            return {
                rules: ValidationService.rules(),
                loading: false,
                applyLoading: false,
                applyDialogOpen: false,
                applyResultDialogOpen: false,
                applyPreflight: null,
                applyPreflightError: "",
                applyResult: null,
                applyScope: "DepartmentsAndClubsOnly",
                departmentsFile: null,
                clubsFile: null,
                workspacesFile: null,
                result: null,
                errorMessages: [],
                selectedObjectType: "",
                selectedOutcome: "",
                tablePage: 1,
                tablePageSize: 100,
                departmentsHeaders: "DepartmentNumber;DepartmentName;PostalAddress;PostalCode;City;Telephone",
                clubsHeaders: "DepartmentNumber;DepartmentName;ClubNumber;ClubName;PostalAddress;PostalCode;City;Telephone;VisitingAddress;VisitingPostalText",
                workspacesHeaders: "OrganisationNumber;WorkplaceNumber;RegisterKey;DepartmentNumber;DepartmentName;ClubNumber;ClubName;WorkspaceName;PostalAddress;PostalCode;City;Telephone;VisitingAddress;VisitingPostalCode;VisitingCity"
            };
        }
    }
</script>

<style scoped>
    .register-maintenance-info-alert {
        margin-bottom: 2rem;
    }

    .register-maintenance-upload-row {
        margin-top: 0.5rem;
    }

    .report-dashboard-card {
        background: #ffffff;
        border: 1px solid #dee2e6;
        border-radius: 6px;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
        min-height: 82px;
        padding: 14px 16px;
    }

    .dashboard-label {
        color: #6c757d;
        font-size: 0.85rem;
        font-weight: 600;
        margin-bottom: 6px;
        text-transform: uppercase;
    }

    .dashboard-value {
        color: #212529;
        font-size: 1.45rem;
        font-weight: 700;
    }

    .matching-guide-panels {
        border: 1px solid #dee2e6;
        border-radius: 6px;
    }

    .matching-guide-panel-title {
        font-weight: 600;
        gap: 10px;
    }

    .matching-guide-icon {
        flex-shrink: 0;
    }

    .matching-guide {
        line-height: 1.65;
        padding: 4px 2px 8px;
    }

    .matching-guide-section {
        margin-bottom: 20px;
        padding-bottom: 4px;
    }

    .matching-guide-section-last {
        margin-bottom: 0;
    }

    .matching-guide-heading {
        color: #212529;
        font-size: 0.95rem;
        font-weight: 700;
        margin-bottom: 8px;
    }

    .matching-guide-text {
        color: #495057;
        line-height: 1.65;
        margin-bottom: 0;
    }

    .matching-guide-text code,
    .matching-guide-note code {
        margin: 0 2px;
    }

    .matching-guide-note {
        align-items: flex-start;
        background-color: #f8f9fa;
        border-left: 3px solid #0d6efd;
        border-radius: 4px;
        display: flex;
        gap: 12px;
        margin-top: 14px;
        padding: 12px 14px;
    }

    .matching-guide-note-icon {
        color: #0d6efd;
        flex-shrink: 0;
        margin-top: 2px;
    }

    .matching-guide-note strong {
        display: block;
        margin-bottom: 6px;
    }

    .dashboard-file-name {
        color: #212529;
        font-weight: 600;
        overflow-wrap: anywhere;
    }

    .summary-dashboard {
        display: grid;
        gap: 12px;
        grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    }

    .summary-card {
        background: #ffffff;
        border: 1px solid #dee2e6;
        border-radius: 6px;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
        padding: 12px 14px;
    }

    .summary-card-header {
        align-items: flex-start;
        display: flex;
        flex-direction: column;
        gap: 6px;
        min-height: 54px;
    }

    .summary-outcome {
        border-radius: 999px;
        font-size: 0.78rem;
        font-weight: 600;
        padding: 2px 8px;
    }

    .summary-outcome-create {
        background-color: #cff4fc;
        color: #055160;
    }

    .summary-outcome-conflict {
        background-color: #f8d7da;
        color: #842029;
    }

    .summary-outcome-ignored {
        background-color: #e9ecef;
        color: #495057;
    }

    .summary-outcome-update {
        background-color: #fff3cd;
        color: #664d03;
    }

    .summary-outcome-exists {
        background-color: #d1e7dd;
        color: #0f5132;
    }

    .summary-count {
        color: #212529;
        font-size: 1.8rem;
        font-weight: 700;
        line-height: 1;
        margin-top: 12px;
    }

    .register-maintenance-table-wrapper {
        overflow-x: auto;
        width: 100%;
    }

    .register-maintenance-table {
        border-collapse: collapse;
        min-width: 1600px;
    }

    .register-maintenance-table th,
    .register-maintenance-table td {
        vertical-align: top;
        white-space: normal;
    }

    .register-maintenance-pagination {
        display: flex;
        align-items: center;
        gap: 12px;
        flex-wrap: wrap;
    }

    .register-maintenance-pagination-label {
        color: #495057;
        font-size: 0.95rem;
    }

    .result-column {
        min-width: 120px;
    }

    .row-column {
        min-width: 150px;
    }

    .key-column {
        min-width: 160px;
    }

    .action-column {
        min-width: 70px;
    }

    .message-column {
        min-width: 260px;
    }

    .values-column {
        min-width: 320px;
    }

    .text-cell,
    .dictionary-cell {
        line-height: 1.45;
        word-break: normal;
        overflow-wrap: anywhere;
    }

    .dictionary-value {
        white-space: pre-line;
    }

    .difference-entry {
        background-color: #f8d7da;
        border-left: 3px solid #dc3545;
        border-radius: 2px;
        color: #842029;
        margin-bottom: 2px;
        padding: 2px 4px;
    }
</style>
